const choices = {
    choice1: "Explore",

    choice2: "Contact Us"
}

export default choices;